/**
 * Pages « Pour qui » (/pour/<slug>) : métadonnées et données structurées, partagées par UseCasePage et le
 * pré-rendu du build. Contenu : src/data/useCases.js.
 */
import { buildBreadcrumbJsonLd } from "./blog.js";
import { inlineToText } from "./inline.js";
import { OG_IMAGE_URL, SITE_LANG, SITE_NAME, SITE_URL, absoluteUrl } from "./site.js";

export const tradePagePath = (slug) => `/pour/${slug}`;

export function tradePageMeta(useCase) {
  return {
    title: useCase.title,
    description: useCase.description,
    canonical: absoluteUrl(tradePagePath(useCase.slug)),
  };
}

export function tradePageBreadcrumb(useCase) {
  return [
    { name: "Accueil", path: "/" },
    { name: useCase.label, path: tradePagePath(useCase.slug) },
  ];
}

export const buildTradePageBreadcrumbJsonLd = (useCase) => buildBreadcrumbJsonLd(tradePageBreadcrumb(useCase));

/** WebPage dont le sujet est le logiciel : relie la page métier à l'entité FlowGantt pour les moteurs. */
export function buildTradePageJsonLd(useCase) {
  const url = absoluteUrl(tradePagePath(useCase.slug));
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": url,
    url,
    name: useCase.h1,
    description: useCase.description,
    abstract: inlineToText(useCase.summary),
    inLanguage: SITE_LANG,
    dateModified: useCase.updated,
    image: OG_IMAGE_URL,
    keywords: useCase.keywords.join(", "),
    isPartOf: { "@type": "WebSite", name: SITE_NAME, url: `${SITE_URL}/` },
    about: { "@type": "SoftwareApplication", name: SITE_NAME, url: `${SITE_URL}/`, applicationCategory: "BusinessApplication" },
    audience: { "@type": "BusinessAudience", name: useCase.label },
    publisher: { "@type": "Organization", name: SITE_NAME, url: SITE_URL },
  };
}
